import { render } from "./ProfilView.vue?vue&type=template&id=0a1a1e63"
import script from "./ProfilView.vue?vue&type=script&lang=js"
export * from "./ProfilView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__